import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { LavaLand_1Screen } from "../LavaLand/game_1Screen";


    export class LavaLandLink_1Screen extends LavaLand_1Screen {      
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "LavaLandLink");
       }

    }